import { httpClient } from "@/lib/http-client";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "@/lib/paraglide-react";
import { parseKeyImage } from "@/utils/parse-key-image";
import { Route } from "/app/src/routes/{-$locale}/items/$id/images.tsx";
const SplitComponent = () => {
  const {
    t
  } = useTranslation();
  const {
    id
  } = Route.useParams();
  const {
    data: item
  } = useQuery({
    queryKey: ["item", {
      id
    }],
    queryFn: () => httpClient.get<SingleItem>(`/items/${id}`)
  });
  if (!item) {
    return null;
  }
  return <div className="flex flex-col items-start justify-start h-full gap-4 w-full">
        <h2 className="text-xl font-bold">{t("items.images.title")}</h2>
        <div className=" mt-2">
          <div className="flex flex-row items-start justify-start flex-wrap gap-2">
            {item.keyImages.map(parseKeyImage).map(media => <div key={media.md5} className="flex flex-col gap-2 items-start justify-start w-1/3">
                <img src={media.mediaType === "image" ? media.imageUrl : media.coverUrl} alt={item.title} className="rounded-lg h-auto  object-cover" />
                <span className="text-sm text-muted-foreground w-full text-center">
                  {media.type}
                </span>
              </div>)}
          </div>
        </div>
      </div>;
};
export { SplitComponent as component };